type Protocol = string;

const PROTOCOL_STYLES: Record<string, string> = {
  V2: "bg-[rgba(76,175,80,0.15)] text-[var(--color-success)]",
  V3: "bg-[rgba(100,181,246,0.15)] text-[#64b5f6]",
  V4: "bg-[rgba(156,39,176,0.15)] text-[#ce93d8]",
  ERC20: "text-gold bg-[rgba(201,168,76,0.15)]",
  "ERC-8004": "bg-[rgba(255,152,0,0.15)] text-[var(--color-warning)]",
  UniswapX: "bg-[rgba(255,171,64,0.15)] text-[#ffab40]",
  CORE: "bg-[rgba(201,168,76,0.15)] text-[var(--color-gold)]",
  ROUTER: "bg-[rgba(100,181,246,0.15)] text-[#64b5f6]",
  // Event type badges
  Transfer: "bg-[rgba(96,165,250,0.15)] text-blue-400",
  Approval: "bg-[rgba(251,191,36,0.15)] text-amber-400",
  Swap: "bg-[rgba(192,132,252,0.15)] text-purple-400",
  Deposit: "bg-[rgba(74,222,128,0.15)] text-green-400",
  Withdrawal: "bg-[rgba(74,222,128,0.15)] text-green-400",
  Mint: "bg-[rgba(45,212,191,0.15)] text-teal-400",
  Burn: "bg-[rgba(45,212,191,0.15)] text-teal-400",
  Sync: "bg-[rgba(34,211,238,0.15)] text-cyan-400",
  PoolCreated: "bg-[rgba(201,168,76,0.15)] text-[var(--color-gold)]",
};

const DEFAULT_STYLE = "text-text-muted bg-[rgba(255,255,255,0.05)]";

export function ProtocolBadge({ protocol }: { protocol: Protocol }) {
  const style = PROTOCOL_STYLES[protocol] ?? DEFAULT_STYLE;
  return (
    <span
      className={`inline-block rounded-[2px] px-[8px] py-[2.5px] font-mono text-[7.5px] uppercase tracking-[0.10em] ${style}`}
    >
      {protocol}
    </span>
  );
}
